import { Component, Injector, OnInit, AfterViewInit } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { CheckOutSuccessOutput, CheckOutServiceProxy } from '@shared/service-proxies/service-proxies';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppAuthService } from '@app/shared/common/auth/app-auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AbpModule } from 'abp-ng2-module';
import { UtilsModule } from '@shared/utils/utils.module';
import { environment } from 'environments/environment';
@Component({
    selector: 'app-anonymoususer.checkout.success',
    templateUrl: './anonymoususer.checkout.success.component.html',
    animations: [appModuleAnimation()],
    standalone: true,
    imports: [FormsModule, NgbModule, UtilsModule, AbpModule, CommonModule, RouterModule]
})

export class AnonymousUserCheckOutSuccessComponent extends AppComponentBase implements OnInit, AfterViewInit {
    public checkOutSuccessOutput: CheckOutSuccessOutput = new CheckOutSuccessOutput();
    public stripe: any;
    public checkoutSessionId: string;
    public isDisabled: boolean = true;
    constructor(injector: Injector, private router: Router, private _planService: CheckOutServiceProxy, private activeRoute: ActivatedRoute, private _authService: AppAuthService) {
        super(injector);
    }

    ngOnInit(): void {
        this.checkoutSessionId = this.activeRoute.snapshot.queryParamMap.get('session_id');
        this.isDisabled = true;
        this.CreateSubscription();
    }
    ngAfterViewInit() {
        $('#aContinueToHomepage').on('click', (e) => {
            this.appSession.init().then((result) => {
                const hostname = location.host.toLowerCase();
                let isFromWebfacing = hostname === environment.WebFacingHost.toLowerCase();
                if (isFromWebfacing) {
                    location.href = "/";
                    return;
                }
                this.router.navigateByUrl("/app/main/projects" + '?v=' + this.appSession.application.version);
            });
        });

    }
    CreateSubscription(): void {
        setTimeout(() => {
            this._planService.createSubscription(this.checkoutSessionId).subscribe(result => {
                if (result !== undefined && result !== null) {
                    this.checkOutSuccessOutput = result;
                    setTimeout(() => {
                        this.appSession.init().then((result) => {
                            const hostname = location.host.toLowerCase();
                            let isFromWebfacing = hostname === environment.WebFacingHost.toLowerCase();
                            if (isFromWebfacing) {
                                location.href = "/";
                                return;
                            }
                            this.router.navigateByUrl("/app/main/projects" + '?v=' + this.appSession.application.version);
                        });
                    }, 5000);
                }
            }, () => { }, () => { this.isDisabled = false; });
        }, 5000);
    }
}
